import 'mocks';
import 'nprogress/nprogress.css';

import App from 'App';
import { AuthProvider } from 'contexts/JWTAuthContext';
import { SidebarProvider } from 'contexts/SidebarContext';
import ScrollTop from 'hooks/useScrollTop';
import { QueryProvider } from 'libs/QueryProvider';
import { SnackbarProvider } from 'notistack';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import * as serviceWorker from 'serviceWorker';
import store from 'store';

const persistor = persistStore(store);
const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryProvider>
          <SidebarProvider>
            <BrowserRouter>
              <ScrollTop />
              <AuthProvider>
                <SnackbarProvider
                  maxSnack={6}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                >
                  <App />
                </SnackbarProvider>
              </AuthProvider>
            </BrowserRouter>
          </SidebarProvider>
        </QueryProvider>
      </PersistGate>
    </Provider>
  </HelmetProvider>,
);

serviceWorker.unregister();
